<sbnb-apps-detail-page
  vendorCode="HostBuddyAI"
  name="HostBuddy AI"
  logoTile="/assets/images/apps/host-buddy-ai.png"
  builtBy="HostBuddy AI"
  builtByLink="https://www.hostbuddy.ai"
  [categories]="['Guest Communication']"
  [permissions]="[
    AppPermission.propertyListingRead,
    AppPermission.reservationRead,
    AppPermission.financialsRead,
    AppPermission.calendarRead,
    AppPermission.calendarWrite,
    AppPermission.messageWrite
  ]"
  email="support@hostbuddy.ai"
  [helpArticles]="[{ id: '10523900', title: 'Connect Hospitable to HostBuddy for AI-powered guest communications' }]">
  <ng-container description>
    <p>
      HostBuddy AI automates guest communication for short-term rental hosts using cutting-edge AI technology. Developed
      by experienced Superhosts, HostBuddy AI was built to provide a seamless and personalized experience to guests
      without compromising quality. Connecting your PMS account allows HostBuddy AI to integrate smoothly with your
      existing system to allow for channel messaging and expedited onboarding.
    </p>

    <p class="mt-1">
      HostBuddy AI offers extensive customization and full host control for scheduling coverage, including the ability
      to customize the AI's tone to match your brand voice perfectly. Action items requiring host attention are
      generated from guest conversations and delivered via Slack, email, and text, keeping your team informed. With
      HostBuddy AI, guests receive timely and helpful responses whenever you are unavailable.
    </p>

    <p class="mt-1">
      Seamlessly onboard by pulling conversational data and listing details directly from your PMS account. Plus,
      enhance your direct booking website with our embeddable chat widget to automatically handle pre-booking inquiries.
      HostBuddy AI ensures efficient guest communication, reducing hosts' workload and allowing more time to prioritize
      other tasks. Welcome to the future of hosting!
    </p>

    <h3 class="text-lg font-medium mt-6 mb-2">List of Primary Features</h3>
    <ul class="list-disc pl-6 space-y-2">
      <li>
        <strong>24/7 Automated Guest Communication:</strong>
        Ensure seamless support around the clock.
      </li>
      <li>
        <strong>Effortless Onboarding:</strong>
        Utilize autofill from your PMS integration, property documents, and existing property profiles.
      </li>
      <li>
        <strong>Customizable Scheduling:</strong>
        Tailor your communication schedules to meet your needs.
      </li>
      <li>
        <strong>Action Items:</strong>
        Get notified when issues require your attention.
      </li>
      <li>
        <strong>Upsells:</strong>
        Automatically upsell vacant nights to boost revenue.
      </li>
      <li>
        <strong>Smart Templates:</strong>
        Target the right guests at the right time.
      </li>
      <li>
        <strong>Smart Inbox:</strong>
        Connect and communicate over various platforms, manually send and receive guest messages and track guest
        sentiment.
      </li>
      <li>
        <strong>Embeddable Chat Widget:</strong>
        Supercharge your direct booking site and support pre-booking inquiries.
      </li>
    </ul>
    <div class="my-6" style="position: relative; padding-bottom: 62.5%; height: 0">
      <iframe
        src="https://www.loom.com/embed/bc26fca40382496da1c21a59a74784f4?sid=c28e80cd-f949-4e68-b4ae-bdffe12868ba"
        frameborder="0"
        webkitallowfullscreen
        mozallowfullscreen
        allowfullscreen
        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"></iframe>
    </div>

    <sbnb-image-carousel
      class="my-6"
      [images]="[
        '/assets/images/apps/host-buddy-ai/1.png',
        '/assets/images/apps/host-buddy-ai/2.png',
        '/assets/images/apps/host-buddy-ai/3.png',
        '/assets/images/apps/host-buddy-ai/4.png',
        '/assets/images/apps/host-buddy-ai/5.png',
        '/assets/images/apps/host-buddy-ai/6.png'
      ]"></sbnb-image-carousel>
  </ng-container>
</sbnb-apps-detail-page>
